export default {
    meta: {
        title: '数据概览',
        isShowNav: true,
    },
};
